<template>
  <div>
    <vs-row vs-type="flex" vs-justify="flex-end">
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="top" vs-w="6">
        <vs-list>
          <vs-list-header :title="$t('GradeControl.Timesheet.VersionList')" color="primary"></vs-list-header>
          <vs-list-item v-for="(listItem, index) in timesheetVersionList" :key="index" :title="createdByUserName(listItem.createdBy)" :subtitle="formatVersionSubtitle(listItem)">
            <vs-avatar slot="avatar" :text="listItem.createdBy" @click="showVersionDetails(index)"/>
            <vs-button radius color="primary" type="border" icon-pack="feather" icon="icon-search" @click="showVersionDetails(index)"></vs-button>
          </vs-list-item>
        </vs-list>  
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-end" vs-align="top" vs-w="6">
        <vs-list>
          <vs-list-header :title="$t('GradeControl.Timesheet.VersionChanged')" color="primary"></vs-list-header>
          <div v-if="selectedTimesheetVersionId !== null">
            <vs-list-item :title="createdByUserName(selectedTimesheetVersionCreatedBy)" :subtitle="creationDate(selectedTimesheetVersionCreationDate)">
              <vs-avatar  slot="avatar" :text="selectedTimesheetVersionCreatedBy" />
            </vs-list-item>
            <vs-list-item v-for="(listItem, index) in selectedTimesheetVersionChangedPropertyList" :key="index" :title="displayPropertyName(listItem.propertyName)" :subtitle="$t('GradeControl.Timesheet.VersionOldValue') + ': ' + listItem.oldValue + ' - ' + $t('GradeControl.Timesheet.VersionNewValue') + ': ' + listItem.newValue">
            </vs-list-item>
            <form-label class="mt-40">{{$t('GradeControl.Timesheet.VersionComment')}}</form-label>
            <vs-textarea v-model="selectedTimesheetVersionComment"/>
          </div>
        </vs-list>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-justify="flex-end">
      <vs-button v-if="selectedTimesheetVersionId !== null" class="mr-6" @click="submitData()">{{$t("Submit")}}</vs-button>
      <vs-button type="border" color="danger" @click="cancel">{{$t("Cancel")}}</vs-button>
    </vs-row>
  </div>
</template>

<script>
import {
  FormLabel
} from "./../../../../shared/components";

export default {
  props: {
    timesheetId: {
      type: Number,
      default: 0
    }
  },
  components: {
    FormLabel
  },
  data() {
    return {
      timesheetVersionList : [],
      selectedTimesheetVersionCreatedBy: "",
      selectedTimesheetVersionCreationDate: "",
      selectedTimesheetVersionId: null,
      selectedTimesheetVersionComment: "",
      selectedTimesheetVersionChangedPropertyList : []
    };
  },
  methods: {
    creationDate(creationDate) {
      const d = new Date(creationDate);
      return d.toLocaleDateString() + " - " + d.toLocaleTimeString();
    },
    createdByUserName(createdBy) {
      if (createdBy === null)
        return null;

      const index = createdBy.search("@");
      if (index !== -1) {
        return createdBy.substring(0, index);
      }
      return createdBy;
    },
    formatVersionSubtitle(listItem) {
      if (listItem.comment !== null && listItem.comment !== 'undefined') {
        return this.creationDate(listItem.creationDate) + " - " + this.$t('GradeControl.Timesheet.VersionEventType.' + listItem.eventType) + " - " + listItem.comment;
      }
      else {
        return this.creationDate(listItem.creationDate) + " - " + this.$t('GradeControl.Timesheet.VersionEventType.' + listItem.eventType);  
      }
    },
    displayPropertyName(propertyName) {
      const key = 'GradeControl.Timesheet.VersionProperties.' + propertyName;
      const translatedValue = this.$t(key);
      return translatedValue === key ? propertyName : translatedValue;
    },
    showVersionDetails(index) {
      const obj = this.timesheetVersionList[index];
      this.selectedTimesheetVersionId = index;
      this.selectedTimesheetVersionCreatedBy = obj.createdBy;
      this.selectedTimesheetVersionCreationDate = obj.creationDate;
      this.selectedTimesheetVersionChangedPropertyList = obj.changedProperties;
      this.selectedTimesheetVersionComment = obj.comment;
    },
    initValues() {
      this.selectedTimesheetVersionId = null;
      this.selectedTimesheetVersionComment = "";
      this.selectedTimesheetVersionChangedPropertyList = null;
    },
    cancel() {
      this.$emit("onClosed");
    },
    submitData() {
      const obj = this.timesheetVersionList[this.selectedTimesheetVersionId];
      obj.comment = this.selectedTimesheetVersionComment;
      this.$vs.loading();
      this.$webApi.post("geo/gradeControl/TimesheetStagingEntry/EditTimesheetChange/", obj)
        .then(() => {
          this.$vs.notify({
            title: this.$t("Success"),
            text: this.$t("GradeControl.Timesheet.VersionUpdateComplete"),
            color: "success",
            iconPack: 'feather',
            icon:'icon-check'
          });
        })
        .catch((error) => {
          console.log(error);
          this.$vs.notify({
            title: this.$t("SavingError"),
            text: error.message,
            color: "danger",
            iconPack: 'feather',
            icon:'icon-check'
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    }
  },
  watch: {
    timesheetId(val) {
      if (!val) return;

      this.selectedTimesheetVersionCreatedBy =  "";
      this.selectedTimesheetVersionCreationDate =  "";
      this.selectedTimesheetVersionId = null;
      this.selectedTimesheetVersionComment = "";
      this.selectedTimesheetVersionChangedPropertyList = [];

      this.$webApi.get("geo/gradeControl/TimesheetStagingEntry/getChanges/" + this.timesheetId).then((response) => {
        this.timesheetVersionList = response.data;  
      }).catch((error) => {
        this.$vs.notify({
          color: "danger",
          title: this.$t("LoadingError"),
          text: error.message  
        });
      })
    }
  }
};
</script>
